import {createHashHistory, History} from 'history';

const history: History = createHashHistory();

export function redirectToLoggedOut() {
	history.replace('/login');
}

export function redirectToHome() {
	history.replace('/home');
}

export function redirectToConfigEditor() {
	history.replace('/editor');
}

export function redirectToConfigTester() {
	history.replace('/tester');
}

export default history;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/history.ts